import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Icon from './Icon';
import { Link } from 'react-router-dom';
import CardsBranches from './CardsBranches';
import CardsAssistant from './CardsAssistant';
import CardsPods from './CardsPods';


const ManagerSingleCard = ({ data, heading, initialSection = 'branches', onTabChange }) => {
  const [activeSection, setActiveSection] = useState(initialSection);

  const branchesCount = data?.branches ? String(data.branches.length).padStart(2,'0') : '0';
  const assistantsCount = data?.assistants ? String(data.assistants.length).padStart(2,'0') : '0';
  const podsCount = data?.pods ? String(data.pods.length).padStart(2,'0') : '0';

  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const phone = data?.managerPhone;
  const email = data?.managerEmail;

  return (
    <div className="p-24 rounded-16 app-shadow-sm bg-brand-light mb-24 card-managers">
      {/* Manager header: avatar, name, contact */}
      <div className="mb-16">
        <div className="d-flex align-items-center mb-12 header">
          <div className="avatar-pill me-7"><span className="text-12 fw-700 text-navy">{getInitials(heading)}</span></div>
          <h6 className="text-16 fw-700 text-navy mb-0">{heading}</h6>
        </div>
        <div className="d-flex align-items-center contact-item">
          {phone &&(<>
            <a href={`tel:${phone}`}>
              <div className="d-flex align-items-center contact-item">
                  <img src="/assets/icons/phone.svg" alt="Phone" className="me-6" width="14" height="13" />
                  <span className="text-14 fw-500 text-navy">{phone}</span>
              </div>
            </a>
            <span className="mx-3"></span>
          </>)}
          <a href={`mailto:${email}`}>
            <div className="d-flex align-items-center contact-item">
              <img src="/assets/icons/email.svg" alt="Email" className="me-6" width="14" height="14" />
              <span className="text-14 fw-500 text-navy">{email}</span>
            </div>
          </a>
        </div>
      </div>

      <div className="d-flex align-items-center chip-row mb-16 flex-wrap">
        <button className={`chip-tab ${activeSection === 'branches' ? 'active' : ''}`} onClick={() => {
            setActiveSection('branches');
            onTabChange && onTabChange('branches');
          }}>
          <span className="mask-icon w-h-14 mask-branches" aria-hidden="true"></span>
          <span className="text-12 fw-600">Branches: {branchesCount}</span>
        </button>
        <button className={`chip-tab ${activeSection === 'assistants' ? 'active' : ''}`} onClick={() => {
            setActiveSection('assistants');
            onTabChange && onTabChange('assistants');
          }}>
          <span className="mask-icon w-h-14 mask-assistants" aria-hidden="true"></span>
          <span className="text-12 fw-600">Assistant: {assistantsCount}</span>
        </button>
        <button className={`chip-tab ${activeSection === 'pods' ? 'active' : ''}`} onClick={() => {
            setActiveSection('pods');
            onTabChange && onTabChange('pods');
          }}>
          <span className="mask-icon w-h-14 mask-teams" aria-hidden="true"></span>
          <span className="text-12 fw-600">Pods/Teams: {podsCount}</span>
        </button>
      </div>

      {activeSection === 'branches' && (
        <div className="mb-16">
          {data.branches && data.branches.length > 0 ? (
            <Row>
              {data.branches.map((item, index) => (
                <Col key={index} sm={12} md={6} className='mb-16'>
                  <div className='force-white'>
                    <CardsBranches
                      CardLabel={item.name}
                      totalManagers={item.totalManagers}
                      totalAssistants={item.totalAssistants}
                      totalPods={item.totalPods}
                      PageRoute={`/branches/singlebranch/${item.id}`}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          ) : <div className="mb-10 text-10 fw-400 text-767676">Branches not found</div>}
        </div>
      )}

      {activeSection === 'assistants' && (
        <div className="mb-16">
          {data.assistants && data.assistants.length > 0 ? (
            <Row>
              {data.assistants.map((item, index) => (
                <Col key={index} sm={12} md={6} className='mb-16'>
                  <CardsAssistant
                    CardLabel={item.name}
                    phone={item.phone}
                    email={item.email}
                    PageRoute={`/assistants/singleassistant/${item.id}`}
                    CardColor='bg-white'
                  />
                </Col>
              ))}
            </Row>
          ) : <div className="mb-10 text-10 fw-400 text-767676">Assistants not found</div>}
        </div>
      )}

      {activeSection === 'pods' && (
        <div className="mb-16">
          {data.pods && data.pods.length > 0 ? (
            <Row>
              {data.pods.map((item, index) => (
                <Col key={index} sm={12} md={6} className='mb-16'>
                  <CardsPods
                    CardLabel={item.name}
                    teamLeadName={item.team_lead_name}
                    membersCount={item.total_team_members}
                    PageRoute={`/teams_pods/singlepods/${item.id}`}
                    CardColor='bg-white'
                  />
                </Col>
              ))}
            </Row>
          ) : <div className="mb-10 text-10 fw-400 text-767676">PODS not found</div>}
        </div>
      )}
    </div>
  );
};

export default ManagerSingleCard;
